import { gql } from '@apollo/client/core';

import {
  ORDER_FISCALIZATION_READINESS_FIELDS,
  ORDER_FISCALIZATION_SETTING_FIELDS,
  ORDER_FISCAL_WORKSTATION_FIELDS,
  SHIFT_FIELDS,
} from './fiscalization.fragments.graphql';

export const GET_ORDER_FISCALIZATION_SETUP = gql`
  ${ORDER_FISCALIZATION_READINESS_FIELDS}

  query GetOrderFiscalizationSetup($locationId: ID!) {
    orderFiscalizationReadiness(locationId: $locationId) {
      ...OrderFiscalizationReadinessFields
    }
  }
`;

export const GET_ORDER_REFUND_CONTEXT = gql`
  query GetOrderRefundContext($orderId: ID!) {
    orderRefundContext(orderId: $orderId) {
      online_payments {
        money_part_id
        fiscal_scheme
      }
      online_refunds {
        id
        payment_id
        amount
        status
      }
      fiscalization_required
      cashier_display_name
      allowed_payment_methods
      shift_required
      shift_state
      shift_blocker_reason
      shift_expires_at
      approval_required
      approval_status
      approval_expires_at
      manual_bank_reference_required
      expected_kkt_device_id
    }
  }
`;

export const GET_ORDER_FISCAL_OPERATIONAL_STATUS = gql`
  query GetOrderFiscalOperationalStatus($locationId: ID!) {
    orderFiscalOperationalStatus(locationId: $locationId) {
      fiscalization_enabled
      shifts_enabled
      paused
      pause_reason
      paused_at
      cashier_display_name
      expected_kkt_device_id
      workstation_binding
      browser_workstation_id
      location_closes_at
    }
  }
`;

export const GET_CURRENT_SHIFT = gql`
  ${SHIFT_FIELDS}

  query GetCurrentShift($locationId: ID!) {
    currentShift(locationId: $locationId) {
      ...ShiftFields
    }
  }
`;

/** Строка журнала без `ShiftFields`: резолверы `expires_at`/`cashier_vatin` и сессии ККТ списку не нужны. */
export const GET_SHIFTS = gql`
  query GetShifts($locationId: ID, $dateFrom: Date, $dateTo: Date, $first: Int!, $after: String) {
    shifts(locationId: $locationId, dateFrom: $dateFrom, dateTo: $dateTo, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          status
          opened_at
          closed_at
          closing_cash_diff
          closing_revenue_mors
          closing_revenue_diff
          kkt_sync
          location {
            id
            title
            timezone
          }
          opened_by {
            id
            title
          }
          closed_by {
            id
            title
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const GET_SHIFT = gql`
  ${SHIFT_FIELDS}

  query GetShift($id: ID!) {
    shift(id: $id) {
      ...ShiftFields
      location {
        id
        title
        timezone
      }
      revenue_mors {
        cash
        card
        other
        total
      }
      events {
        id
        type
        created_at
        actor {
          id
          title
        }
      }
    }
  }
`;

export const UPDATE_ORDER_FISCALIZATION_SETTINGS = gql`
  ${ORDER_FISCALIZATION_SETTING_FIELDS}

  mutation UpdateOrderFiscalizationSettings($input: UpdateOrderFiscalizationSettingsInput!) {
    updateOrderFiscalizationSettings(input: $input) {
      ...OrderFiscalizationSettingFields
    }
  }
`;

export const APPLY_ORDER_FISCALIZATION_CONNECTION = gql`
  ${ORDER_FISCALIZATION_SETTING_FIELDS}
  ${ORDER_FISCAL_WORKSTATION_FIELDS}

  mutation ApplyOrderFiscalizationConnection($input: ApplyOrderFiscalizationConnectionInput!) {
    applyOrderFiscalizationConnection(input: $input) {
      ...OrderFiscalWorkstationFields
      setting {
        ...OrderFiscalizationSettingFields
      }
    }
  }
`;

export const DEACTIVATE_ORDER_FISCAL_WORKSTATION = gql`
  ${ORDER_FISCAL_WORKSTATION_FIELDS}

  mutation DeactivateOrderFiscalWorkstation($locationId: ID!, $workstationId: ID!) {
    deactivateOrderFiscalWorkstation(locationId: $locationId, workstationId: $workstationId) {
      ...OrderFiscalWorkstationFields
    }
  }
`;

export const DELETE_ORDER_FISCAL_WORKSTATION = gql`
  mutation DeleteOrderFiscalWorkstation($locationId: ID!, $workstationId: ID!) {
    deleteOrderFiscalWorkstation(locationId: $locationId, workstationId: $workstationId)
  }
`;
